import script from "./LegendPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LegendPanel.vue?vue&type=script&setup=true&lang=js"

import "./LegendPanel.vue?vue&type=style&index=0&id=69a221f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a221f0"]])

export default __exports__